import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ToplineComponent } from './topline.component';
import { ExcelViewerComponent } from '../repository/excel-viewer/excel-viewer.component';
import { CreatToplineComponent } from '../repository/creat-topline/creat-topline.component';

const routes: Routes = [{
  path:'',
  component:ToplineComponent,
  children:[
    { path: 'excel-view/:uuid', component: ExcelViewerComponent },
    { path: 'report/:uuid', component:CreatToplineComponent},
    { path: 'report/alias/:uuid', component:CreatToplineComponent},
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ToplineRoutingModule { }
